import { Moment } from 'moment';

import {
  SearchUserEventsRequestDtoOperationsEnum,
  SearchUserEventsRequestDtoProfilsEnum,
  SearchUserEventsResultDto,
  UserEventDto,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useHandleBackErrors } from 'hooks/utils/handleBackErrors';
import { FetchDataFunction } from 'types/searchType';
import { convertMomentToIsoString } from 'utils/MomentConverters';

import { UtilisateursResponseDto } from './utils';

export interface Filters {
  dateRangeRealisation: [Moment | undefined, Moment | undefined];
  operations: SearchUserEventsRequestDtoOperationsEnum[];
  profils: SearchUserEventsRequestDtoProfilsEnum[];
}

export enum SortOptions {
  'DATE_REALISATION' = 'DATE_REALISATION',
  'TYPE_ACTION' = 'TYPE_ACTION',
}

export function useSearchUserEventsDto(): FetchDataFunction<
  UtilisateursResponseDto,
  Filters,
  SortOptions
> {
  const controllerApi = useApi().AdminFonctionnelControllerApi;
  const behaviourOnError = useHandleBackErrors();

  return async (pagination, sorters, filters) => {
    const dateDebut =
      convertMomentToIsoString(filters.dateRangeRealisation?.[0]) ?? null;
    const dateFin =
      convertMomentToIsoString(filters.dateRangeRealisation?.[1]) ?? null;

    const result: SearchUserEventsResultDto = await controllerApi
      .searchUserEventsUsingPOST({
        page: pagination.page - 1, // page (pagination in frontend start at index 1, while backend start at 0)
        pageSize: pagination.pageSize,
        dateDebut,
        dateFin,
        operations: filters.operations ?? null,
        profils: filters.profils ?? null,
        sortByDate: sorters.DATE_REALISATION ?? null,
        sortByOperationType: sorters.TYPE_ACTION ?? null,
      })
      .catch((error: Response) => {
        behaviourOnError(error);
        throw error;
      });

    const data: UtilisateursResponseDto[] =
      result.events?.map((event: UserEventDto) => ({
        id: event.date,
        dateRealisation: event.date,
        typeAction: event.operationType ?? '',
        role: event.profile ?? '',
        entiteRattachement: event.libelleEntiteRattachement ?? '',
      })) || [];

    return {
      hasNextPage: result.hasNextPage ?? false,
      data,
      total: result.totalResults ?? 0,
    };
  };
}
